import React from 'react';
import userStore from '../../store/userStore';
import AdminTree from '../admin/adminTree';
import AdminCenter from '../adminCenter/AdminCenter';
import PageHoc from '../../HoC/PageHoC';
import AdminController from '../adminController/AdminController';

class Admin extends React.Component {
    constructor() {
        super();
        this.state = {
            loggedIn: false,
            notAdmin: false
        };
    }
    notAdmin = () => {
        this.props.history.push("/");
    };
    componentWillMount() {
        if (userStore.user.privilege !== "ADMIN"
            || this.state.notAdmin) {
            this.notAdmin();
        }
    }

    redirect = (url) => this.props.history.push(url);

    render() {

        let display;
        if (this.props.location.pathname === "/admin") {
            display = (<div>
                <h2>Admin Centre</h2>
                <AdminCenter notAdmin={this.notAdmin} />
            </div>);
        } else if (this.props.location.pathname === "/adminPublish") {
            display = (<div>
                <h2>Publish Trees</h2>
                <AdminTree notAdmin={this.notAdmin} redirect={this.redirect} /></div>);
        } else if (this.props.location.pathname === "/adminController") {
            display = (<div>
                <h2>View Companies</h2>
                <AdminController notAdmin={this.notAdmin} /></div>);
        }
        return (
            <div>
                <div className="container" id="container" style={{ top: "12vh" }}>
                    {/* <AdminTree />
                     */}
                    {display}
                </div>
            </div>
        );
    }
}
export default PageHoc(Admin);


// WEBPACK FOOTER //
// ./src/components/Pages/Admin.js